import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { AthleteRoutingModule } from './athlete-routing.module';
import { CommonPageComponentsModule } from '../common-page-components/common-page-components.module';
import { ServicesModule } from 'world-archery-lib';
import { FiltersAthleteGeneralService } from './services/filters-athlete-general.service';
import { BootstrapAthleteComponent, AngularEmbedScript } from './components/bootstrap-athlete/bootstrap-athlete.component';
import { ComponentsModule } from 'world-archery-lib';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ResultsAthleteFiltersService } from './athlete-results/services/results-athlete-filters.service';
import { ProxyAthleteComponent } from './components/proxy-athlete/proxy-athlete.component';

@NgModule({
  declarations: [BootstrapAthleteComponent, ProxyAthleteComponent],
  imports: [
    CommonModule,
    AthleteRoutingModule,
    CommonPageComponentsModule,
    ComponentsModule
  ],
  providers:[
  ]
})
export class AthleteModule { }
